import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, ref } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import SimpleForm from "@/components/SimpleForm.vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateReferralCodeForAccount',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {

const modalRef = ref();
const { t } = useI18n();
const ruleFormRef = ref();
const isLoading = ref(true);
const formData = ref({} as any);
const accountDetails = inject<any>(AccountInjectionKeys.ACCOUNT_DETAILS, {});



const resetForm = async () => {
  formData.value = {
    partyId: accountDetails.value.partyId,
    accountId: accountDetails.value.id,
    name: "",
    serviceType: "",
  };

  ruleFormRef.value?.resetFields();
};

const rules = ref({
  name: [
    {
      required: true,
      message: "Please input code name",
      trigger: "blur",
    },
  ],
  serviceType: [
    {
      required: true,
      message: "Please select service type",
      trigger: "change",
    },
  ],
});

const submit = async () => {
  if (!formData.value.name || !formData.value.serviceType) {
    MsgPrompt.warning(t("tip.pleaseCompleteAllRequiredFields"));
    return;
  }

  if (formData.value.summary && formData.value.summary != "") {
    try {
      JSON.parse(formData.value.summary);
      formData.value.summary = JSON.stringify(
        JSON.parse(formData.value.summary)
      );
    } catch (error) {
      MsgPrompt.warning("Invalid JSON format");
      return;
    }
  } else {
    delete formData.value.summary;
  }

  try {
    isLoading.value = true;
    await AccountService.addReferralCode({
      ...formData.value,
    });

    MsgPrompt.success("ReferralCode created successfully").then(() => {
      hide();
      emits("fetchData");
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};
const show = async () => {
  await resetForm();
  modalRef.value?.show();
  isLoading.value = false;
};

const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('fields.referralCode'),
    "is-loading": isLoading.value,
    submit: submit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules.value,
        "label-width": "160px",
        class: "demo-ruleForm",
        "status-icon": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Service Type",
            prop: "serviceType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formData.value.serviceType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.serviceType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    key: "IB",
                    label: "IB",
                    value: 300
                  }),
                  _createVNode(_component_el_option, {
                    key: "Client",
                    label: "Client",
                    value: 400
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Name",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Summary",
            prop: "summary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "textarea",
                modelValue: formData.value.summary,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.summary) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})